<mat-calendar
  #availabilityCalendar
  touchUi
  (selectedChange)="onDateSelected($event)"
  [selected]="currentDate"
  [headerComponent]="availabilityHeader"
  [startAt]="currentDate"
  [dateFilter]="dateFilter"
  [minDate]="startDate"
  [dateClass]="dateClass"
  class="availability-calendar">
</mat-calendar>
